$(document).ready(function() {
  //===================
  // setTimeout(function () {
  //   $('.faq_block .faq_main_inner:nth-child(1) .faq_main_wrapper').addClass('active');
  //   $('.faq_block .faq_main_inner:nth-child(1) .faq_answer').slideDown();
  //   $('.faq_question').on('click', function() {
  //     if($(this).hasClass('active')) {
  //       $(this).parent('.faq_main_wrapper').addClass('active');
  //       $(this).siblings('.faq_answer').slideUp();
  //       $(this).removeClass('active');
  //     }
  //     else {
  //       $('.faq_answer').slideUp();
  //       $(this).parent('.faq_main_wrapper').removeClass('active');
  //       $('.faq_question').removeClass('active');
  //       $(this).siblings('.faq_answer').slideToggle();
  //       $(this).toggleClass('active');
  //     }
  //   });
  // }, 2500);

  setTimeout(function () {
    $('.faq_block .faq_main_inner:nth-child(1) .faq_main_wrapper').addClass('active');
    $('.faq_block .faq_main_inner:nth-child(1) .faq_answer').slideDown();
    $('.faq_question').on('click', function() {
      if($(this).hasClass('active')) {
        $(this).parent('.faq_main_wrapper').toggleClass('active');
        $(this).siblings('.faq_answer').slideUp();
        $(this).removeClass('active');
      }
      else {
        $('.faq_answer').slideUp();
        $('.faq_main_wrapper').removeClass('active');
        $('.faq_question').removeClass('active');
        $(this).parent('.faq_main_wrapper').addClass('active');
        $(this).siblings('.faq_answer').slideDown();
        $(this).addClass('active');
      }
    });
  }, 2500);


  //==============
  $('.customer_slider_block').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
  prevArrow: '<button class="slick-prev slick-arrow"><svg width="16" height="13" viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M6.01033 0.166789C5.86319 0.0442437 5.67341 -0.0148567 5.48271 0.00247974C5.29201 0.0198162 5.11599 0.11217 4.99336 0.25924L0.178666 6.03746C0.115253 6.10994 0.0669754 6.19438 0.0366758 6.2858C0.00637628 6.37722 -0.00533418 6.47377 0.00223361 6.56978C0.0098014 6.6658 0.0364949 6.75932 0.0807429 6.84487C0.124991 6.93041 0.1859 7.00624 0.259887 7.0679C0.333874 7.12955 0.419445 7.17579 0.511566 7.20389C0.603686 7.23198 0.700494 7.24137 0.796297 7.2315C0.8921 7.22163 0.984961 7.1927 1.06942 7.14642C1.15387 7.10013 1.22822 7.03741 1.28808 6.96197L6.10278 1.18375C6.22533 1.03661 6.28443 0.846833 6.26709 0.656132C6.24975 0.465431 6.1574 0.289419 6.01033 0.166789Z" fill="#D4840B"/><path fill-rule="evenodd" clip-rule="evenodd" d="M6.01033 12.8332C6.1574 12.7105 6.24975 12.5345 6.26709 12.3438C6.28443 12.1531 6.22533 11.9633 6.10278 11.8162L1.28808 6.03799C1.22822 5.96254 1.15387 5.89983 1.06942 5.85354C0.984961 5.80725 0.892099 5.77832 0.796297 5.76845C0.700494 5.75858 0.603685 5.76797 0.511565 5.79607C0.419445 5.82416 0.333874 5.8704 0.259887 5.93206C0.1859 5.99371 0.124991 6.06954 0.0807426 6.15509C0.0364946 6.24063 0.00980114 6.33416 0.00223335 6.43017C-0.00533443 6.52618 0.00637604 6.62274 0.0366756 6.71416C0.0669751 6.80558 0.115252 6.89001 0.178666 6.9625L4.99336 12.7407C5.11599 12.8878 5.29201 12.9801 5.48271 12.9975C5.67341 13.0148 5.86319 12.9557 6.01033 12.8332Z" fill="#D4840B"/><path fill-rule="evenodd" clip-rule="evenodd" d="M0.733215 6.50011C0.733215 6.69167 0.809312 6.87538 0.944766 7.01084C1.08022 7.14629 1.26393 7.22239 1.45549 7.22239L15.1788 7.22239C15.3703 7.22239 15.554 7.14629 15.6895 7.01084C15.8249 6.87538 15.901 6.69167 15.901 6.50011C15.901 6.30855 15.8249 6.12483 15.6895 5.98938C15.554 5.85393 15.3703 5.77783 15.1788 5.77783L1.45549 5.77783C1.26393 5.77783 1.08022 5.85393 0.944765 5.98938C0.809312 6.12483 0.733215 6.30855 0.733215 6.50011Z" fill="#D4840B"/></svg></button>',
  nextArrow: '<button class="slick-next slick-arrow"><svg width="16" height="13" viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.98967 0.167277C10.1368 0.044732 10.3266 -0.0143685 10.5173 0.00296802C10.708 0.0203045 10.884 0.112658 11.0066 0.259728L15.8213 6.03794C15.8847 6.11043 15.933 6.19487 15.9633 6.28629C15.9936 6.37771 16.0053 6.47426 15.9978 6.57027C15.9902 6.66629 15.9635 6.75981 15.9193 6.84536C15.875 6.9309 15.8141 7.00673 15.7401 7.06839C15.6661 7.13004 15.5806 7.17628 15.4884 7.20438C15.3963 7.23247 15.2995 7.24186 15.2037 7.23199C15.1079 7.22212 15.015 7.19319 14.9306 7.1469C14.8461 7.10062 14.7718 7.0379 14.7119 6.96246L9.89722 1.18424C9.77467 1.0371 9.71557 0.847321 9.73291 0.65662C9.75025 0.465919 9.8426 0.289907 9.98967 0.167277Z" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M9.98967 12.8337C9.8426 12.711 9.75025 12.535 9.73291 12.3443C9.71557 12.1536 9.77467 11.9638 9.89722 11.8167L14.7119 6.03847C14.7718 5.96303 14.8461 5.90032 14.9306 5.85403C15.015 5.80774 15.1079 5.77881 15.2037 5.76894C15.2995 5.75907 15.3963 5.76846 15.4884 5.79656C15.5806 5.82465 15.6661 5.87089 15.7401 5.93254C15.8141 5.9942 15.875 6.07003 15.9193 6.15558C15.9635 6.24112 15.9902 6.33465 15.9978 6.43066C16.0053 6.52667 15.9936 6.62323 15.9633 6.71465C15.933 6.80606 15.8847 6.8905 15.8213 6.96299L11.0066 12.7412C10.884 12.8883 10.708 12.9806 10.5173 12.998C10.3266 13.0153 10.1368 12.9562 9.98967 12.8337Z" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M15.2668 6.5006C15.2668 6.69216 15.1907 6.87587 15.0552 7.01132C14.9198 7.14678 14.7361 7.22287 14.5445 7.22287L0.821246 7.22287C0.629686 7.22287 0.445971 7.14678 0.310518 7.01132C0.175065 6.87587 0.0989694 6.69216 0.0989694 6.5006C0.0989694 6.30904 0.175065 6.12532 0.310518 5.98987C0.445971 5.85442 0.629686 5.77832 0.821246 5.77832L14.5445 5.77832C14.7361 5.77832 14.9198 5.85442 15.0552 5.98987C15.1907 6.12532 15.2668 6.30904 15.2668 6.5006Z" fill="white"/></svg></button>',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        // slidesToScroll: 3
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        // slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        // slidesToScroll: 1
      }
    }
  ],
  });
  //--------
});

//===================
// setInterval(function() {
//   let _ = document.querySelector(".live-view")
//   , t = Math.floor(16 * Math.random() + 15);
//   null != t && null != _ && (_.innerHTML = t)
// }, 15000),

// Live View Products
setInterval(function(){
  function productViewCount(min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min)
  }
  let numberView = document.querySelector('.live-view');
  const rndNum = productViewCount(150 , 250)
  if (rndNum != null && numberView != null)
    numberView.innerHTML = rndNum;
},8000);

//-----------cart-drawer
$('.product-form__buttons button').click( function(){
  setTimeout(function(){
    $('cart-drawer').addClass('active');
  }, 1000);
}); 
$('.sticky-atc__button button').click( function(){
  setTimeout(function(){
    $('cart-drawer').addClass('active');
  }, 1000);
}); 



if (window.matchMedia("(max-width: 768px)").matches) {
  $('.anno_bottom_inn').slick({
  dots: false,
     arrows: false,
      variableWidth: true,
  infinite: true,
  slidesToShow: 1,
    autoplay: true,
    autoplaySpeed: 1,
    speed: 6000,
    cssEase: 'linear',
    waitForAnimate: false,
    pauseOnFocus: false, 
    pauseOnHover: false,
  slidesToScroll: 1
  });
} 

$('.slider_main_top').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: false,
	infinite: false,
	speed: 300,
  asNavFor: '.slider_main_bottom_thumb',
  draggable: false,  
  swipe: false ,
   responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 1,
        swipe: true 
      }
    }
  ]
});
$('.slider_main_bottom_thumb').slick({
  slidesToShow: 5,
  slidesToScroll: 5,
  asNavFor: '.slider_main_top',
  dots: false,
  infinite: false,
  centerMode: false,
  focusOnSelect: true,
 swipe: true,
  prevArrow: '<button class="slick-prev slick-arrow"><svg width="16" height="13" viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M6.01033 0.166789C5.86319 0.0442437 5.67341 -0.0148567 5.48271 0.00247974C5.29201 0.0198162 5.11599 0.11217 4.99336 0.25924L0.178666 6.03746C0.115253 6.10994 0.0669754 6.19438 0.0366758 6.2858C0.00637628 6.37722 -0.00533418 6.47377 0.00223361 6.56978C0.0098014 6.6658 0.0364949 6.75932 0.0807429 6.84487C0.124991 6.93041 0.1859 7.00624 0.259887 7.0679C0.333874 7.12955 0.419445 7.17579 0.511566 7.20389C0.603686 7.23198 0.700494 7.24137 0.796297 7.2315C0.8921 7.22163 0.984961 7.1927 1.06942 7.14642C1.15387 7.10013 1.22822 7.03741 1.28808 6.96197L6.10278 1.18375C6.22533 1.03661 6.28443 0.846833 6.26709 0.656132C6.24975 0.465431 6.1574 0.289419 6.01033 0.166789Z" fill="#D4840B"/><path fill-rule="evenodd" clip-rule="evenodd" d="M6.01033 12.8332C6.1574 12.7105 6.24975 12.5345 6.26709 12.3438C6.28443 12.1531 6.22533 11.9633 6.10278 11.8162L1.28808 6.03799C1.22822 5.96254 1.15387 5.89983 1.06942 5.85354C0.984961 5.80725 0.892099 5.77832 0.796297 5.76845C0.700494 5.75858 0.603685 5.76797 0.511565 5.79607C0.419445 5.82416 0.333874 5.8704 0.259887 5.93206C0.1859 5.99371 0.124991 6.06954 0.0807426 6.15509C0.0364946 6.24063 0.00980114 6.33416 0.00223335 6.43017C-0.00533443 6.52618 0.00637604 6.62274 0.0366756 6.71416C0.0669751 6.80558 0.115252 6.89001 0.178666 6.9625L4.99336 12.7407C5.11599 12.8878 5.29201 12.9801 5.48271 12.9975C5.67341 13.0148 5.86319 12.9557 6.01033 12.8332Z" fill="#D4840B"/><path fill-rule="evenodd" clip-rule="evenodd" d="M0.733215 6.50011C0.733215 6.69167 0.809312 6.87538 0.944766 7.01084C1.08022 7.14629 1.26393 7.22239 1.45549 7.22239L15.1788 7.22239C15.3703 7.22239 15.554 7.14629 15.6895 7.01084C15.8249 6.87538 15.901 6.69167 15.901 6.50011C15.901 6.30855 15.8249 6.12483 15.6895 5.98938C15.554 5.85393 15.3703 5.77783 15.1788 5.77783L1.45549 5.77783C1.26393 5.77783 1.08022 5.85393 0.944765 5.98938C0.809312 6.12483 0.733215 6.30855 0.733215 6.50011Z" fill="#D4840B"/></svg></button>',
  nextArrow: '<button class="slick-next slick-arrow"><svg width="16" height="13" viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.98967 0.167277C10.1368 0.044732 10.3266 -0.0143685 10.5173 0.00296802C10.708 0.0203045 10.884 0.112658 11.0066 0.259728L15.8213 6.03794C15.8847 6.11043 15.933 6.19487 15.9633 6.28629C15.9936 6.37771 16.0053 6.47426 15.9978 6.57027C15.9902 6.66629 15.9635 6.75981 15.9193 6.84536C15.875 6.9309 15.8141 7.00673 15.7401 7.06839C15.6661 7.13004 15.5806 7.17628 15.4884 7.20438C15.3963 7.23247 15.2995 7.24186 15.2037 7.23199C15.1079 7.22212 15.015 7.19319 14.9306 7.1469C14.8461 7.10062 14.7718 7.0379 14.7119 6.96246L9.89722 1.18424C9.77467 1.0371 9.71557 0.847321 9.73291 0.65662C9.75025 0.465919 9.8426 0.289907 9.98967 0.167277Z" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M9.98967 12.8337C9.8426 12.711 9.75025 12.535 9.73291 12.3443C9.71557 12.1536 9.77467 11.9638 9.89722 11.8167L14.7119 6.03847C14.7718 5.96303 14.8461 5.90032 14.9306 5.85403C15.015 5.80774 15.1079 5.77881 15.2037 5.76894C15.2995 5.75907 15.3963 5.76846 15.4884 5.79656C15.5806 5.82465 15.6661 5.87089 15.7401 5.93254C15.8141 5.9942 15.875 6.07003 15.9193 6.15558C15.9635 6.24112 15.9902 6.33465 15.9978 6.43066C16.0053 6.52667 15.9936 6.62323 15.9633 6.71465C15.933 6.80606 15.8847 6.8905 15.8213 6.96299L11.0066 12.7412C10.884 12.8883 10.708 12.9806 10.5173 12.998C10.3266 13.0153 10.1368 12.9562 9.98967 12.8337Z" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M15.2668 6.5006C15.2668 6.69216 15.1907 6.87587 15.0552 7.01132C14.9198 7.14678 14.7361 7.22287 14.5445 7.22287L0.821246 7.22287C0.629686 7.22287 0.445971 7.14678 0.310518 7.01132C0.175065 6.87587 0.0989694 6.69216 0.0989694 6.5006C0.0989694 6.30904 0.175065 6.12532 0.310518 5.98987C0.445971 5.85442 0.629686 5.77832 0.821246 5.77832L14.5445 5.77832C14.7361 5.77832 14.9198 5.85442 15.0552 5.98987C15.1907 6.12532 15.2668 6.30904 15.2668 6.5006Z" fill="white"/></svg></button>',
  responsive: [
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 5,
      }
    }
  ]
});

$('.review_slider_main').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
    dots: true,
  adaptiveHeight: true,
  fade: false,
	speed: 300,
});
